import request from '@/utils/request';
import { getDeviceId } from '@/utils/index';

// 获取二维码
export function getQrcode() {
  return request.get('/wxScan_api/wxLogin');
}
// 获取登录状态
export function getLoginStatus(pLoginKey) {
  return request.post('/wxScan_api/getWxLoginInfo', {
    loginKey: pLoginKey,
  });
}
// 扫码登录
export function scanLogin(pToken) {
  request.defaults.headers.token = pToken;
  return request.post('/dengLuHm/gogogo');
}
// 账号密码登录（新端：new_login=1 + 固定 deviceId，按需带短信验证码）
export function inputLogin(pObj) {
  const payload = {
    phonenumber: pObj.phone,
    passwd: pObj.password,
    bindId: pObj.bindId,
    h5_openId: pObj.h5_openid,
    new_login: '1',
    deviceId: pObj.deviceId || getDeviceId(),
  };
  if (pObj.code) {
    payload.code = pObj.code;
  }
  if (pObj.codeId) {
    payload.codeId = pObj.codeId;
  }
  return request.post('/dengLuHm/gogogo', payload);
}

// 注册
export function register(pObj) {
  return request.post('/dengLuHm/zhuCeNe', {
    phonenumber: pObj.phone,
    passwd: pObj.password,
    invite_key: pObj.inviteCode,
    code: pObj.valiCode,
    token: pObj.ext,
    h5_openId: pObj.openId || pObj.h5_openid,
    id: pObj.codeId,
    bindId: pObj.bindId,
    // h5_openid: pObj.h5_openid,
  });
}
// 发送验证码
export function sendCode(pObj) {
  return request.post('/dengLuHm/faSongCode', {
    phonenumber: pObj.phone,
    source: pObj.source,
  });
}
// 修改密码
export function resetPassword(pObj) {
  return request.post('/dengLuHm/updateMiMa', {
    phonenumber: pObj.phone,
    codeId: pObj.codeId,
    passwd: pObj.password,
    token: pObj.ext,
    code: pObj.valiCode,
  });
}

// 修改密码
export function getList({
  showCount,
  currentPage,
}) {
  return request.post('/wxt/getSystemWxtInfoListPage', {
    currentPage,
    showCount,
  });
}

// 获取轮播
export function getCarouselList() {
  return request.post('/dengLuHm/getLbt', {
    sys_type: '2',
    bg_type: '6',
  });
}

export function getShouYeInfo() {
  return request.post('/team/getShouYeInfo', {});
}

export function getProductList() {
  return request.get('/courseinfo/getCourseinfoList', {});
}

// 获取图形验证码
export function getGraphicCaptcha() {
  return request.get('/captchaHm/getGraphicCaptcha');
}
// 携带图形验证码发送短信验证码
export function sendSmsCodeWithCaptcha(pObj) {
  return request.post('/captchaHm/sendSmsCodeWithCaptcha', {
    phonenumber: pObj.phone,
    source: pObj.source,
    captchaId: pObj.captchaId,
    captchaCode: pObj.captchaCode,
  }).then((res) => {
    if (res.code === 200 && res.data) {
      return {
        code: res.data.code,
        msg: res.data.msg,
        data: res.data.data || {},
      };
    }
    return {
      code: String(res.code),
      msg: res.msg,
      data: {},
    };
  });
}
